var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3957 15.3439C40.1339 14.534 39.4155 13.9587 38.5656 13.8821L27.0205 12.8338L22.4552 2.14841C22.1186 1.36531 21.352 0.858398 20.5002 0.858398C19.6484 0.858398 18.8818 1.36531 18.5452 2.15024L13.98 12.8338L2.43303 13.8821C1.58462 13.9605 0.868046 14.534 0.604673 15.3439C0.341299 16.1539 0.584531 17.0423 1.22633 17.6023L9.95306 25.2557L7.37975 36.5911C7.19145 37.4246 7.51495 38.2861 8.20649 38.786C8.57821 39.0546 9.01309 39.1913 9.45164 39.1913C9.82976 39.1913 10.2048 39.0894 10.5415 38.8879L20.5002 32.9359L30.4553 38.8879C31.1838 39.3262 32.1021 39.2862 32.7921 38.786C33.4839 38.2846 33.8071 37.4227 33.6188 36.5911L31.0455 25.2557L39.7723 17.6038C40.4141 17.0423 40.6591 16.1554 40.3957 15.3439Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.66d7a734e4dc456a9841134e35171239.svg";
export { ForwardRef as ReactComponent };